import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import Header from './Header/Header';
import { getStyles } from './styles';


export default function Landing() {
    const theme = useTheme();
    const styles = getStyles(theme);

    return (
        <>
        <Header openHamburgerMenu={true} />
        <Box sx={styles.root}>
        <h1>Please choose an option from the hamburger menu.</h1>
        </Box>
        </>
    )
}
